// extracted by mini-css-extract-plugin
export default {"Table":"load_Table__O6TUG"};